export interface IScriptLoaderOptions {
    id?: string;
}

export default function loadScript(url: string, options: IScriptLoaderOptions = {}): void {
    const isLoaded = document.querySelectorAll('.search-script');
    if (isLoaded.length > 0) {
        return;
    }

    const script = document.createElement('script');
    script.src = url;

    if (options && options.id) {
        script.id = options.id;
    }

    document.body.appendChild(script);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/script-loader.ts